import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EcgReportComponent } from './ecg-report.component';


const routes: Routes = [
  {
    path: '',
    component: EcgReportComponent,
    // canActivate: [SubscriptionGuard]
  },
  {
    path: "archive",
    component: EcgReportComponent,
    // canActivate: [SubscriptionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EcgReportRoutingModule { }
